import Label from 'LuxKit/Label/Label'
import LuxPlusLogo from 'luxPlus/components/Logos/LuxPlusLogo'
import { useAppSelector } from 'hooks/reduxHooks'
import { getIsLuxPlusEnabled } from 'luxPlus/selectors/featureToggle'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { campaignRegionImages } from 'components/utils/tour-luxplus-campaign-regions'

const LOGO_HEIGHT = 10
const EXCLUDED_TOUR_OFFER_IDS = new Set(['tour-4be7679d-269c-48dc-ab32-83fb321f4aaa'])

interface Props {
  offerId?: string
}

function TourLuxPlusCampaignTag(props: Props) {
  const { offerId } = props
  const luxPlusEnabled = useAppSelector(getIsLuxPlusEnabled)
  const regionCode = useAppSelector(state => state.geo.currentRegionCode)

  if (!luxPlusEnabled || !(regionCode in campaignRegionImages) || (offerId !== undefined && EXCLUDED_TOUR_OFFER_IDS.has(offerId))) return null

  return <Label kind="primary" variant="lux-plus" data-testid="tour-lux-plus-campaign-tag">
    <FormattedMessage
      id="NzC8YXGxX5"
      defaultMessage="Unlock an extra 5% off with {logo}"
      description="Campaign urgency tag for LuxPlus+ members 5% off tour offers"
      values={{ logo: <LuxPlusLogo colour="inherit" height={LOGO_HEIGHT} /> }}
    />
  </Label>
}

export default TourLuxPlusCampaignTag
